<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" style="padding:2em;">
<p class="title dPurple" id="i932a">contents</p>
<p class="sub" id="i1220a"> <a href="#/Introduction">8	Introduction</a></p>
<p class="sub" id="i1220b"> <a href="#/Chapter1">11	Deck the Halls<br/>
<i>Designs for the Home</i></a></p>
<p class="sub" id="i1220c"> <span href="#/Chapter2" title="Link target outside of Sample">65	Warming Up <br/>
<i>Hats, Scarves, Mittens, Gloves, and Socks</i></span></p>
<p class="sub" id="i1220d"> <span href="#/Chapter3" title="Link target outside of Sample">107   Dressing Up<br/>
<i>Sweaters, Shawls, and Party Hats</i></span></p>
<p class="sub" id="i1220e"> <span href="#/Chapter4" title="Link target outside of Sample">153	Packing Up <br/>
<i>Carryalls, Gift Bags, and Last-Minute Gifts</i></span></p>
<p class="sub2" id="i1220f"><span href="#/Techniques" title="Link target outside of Sample"><span class="ch_12">176</span>	   special techniques</span></p>
<p class="sub2" id="i1220f2"><span href="#/title" title="Link target outside of Sample"><span class="ch_12">182</span>	   contributors</span></p>
<p class="sub2" id="i1220f3"><span href="#/Supplies" title="Link target outside of Sample"><span class="ch_12">184</span>	   sources for supplies</span></p>
<p class="sub2" id="i1220f4"><span href="#/acknowledgements" title="Link target outside of Sample"><span class="ch_12">185</span>	   acknowledgments</span></p>
<p class="sub2" id="i1220f5"><span href="#/index" title="Link target outside of Sample"><span class="ch_12">186</span>	   index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5485cfc7